import { render, staticRenderFns } from "./HotelOffersTariffPopupAdapter.vue?vue&type=template&id=a0e0964a&lang=pug&"
import script from "./HotelOffersTariffPopupAdapter.vue?vue&type=script&lang=ts&"
export * from "./HotelOffersTariffPopupAdapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports